import { Row } from "antd";
import { useDataMap } from "../hooks/useDataMap";
import { ITotalCard } from "../types/ITotalCard";
import { DataCard } from "./DataCard";

type DataRowProps = {
  title: string;
  data: any;
};

export const DataRow = ({ title, data }: DataRowProps) => {
  const dataMap = useDataMap();

  return (
    <Row className="w-100 d-block mb-4 totals-row">
      <p className="my-0 text-md card-header w-700 pb-2">{title}</p>

      <Row>
        {dataMap.map((item: ITotalCard, i: number) => (
          <DataCard key={i} data={data} dataMap={item} />
        ))}
      </Row>
    </Row>
  );
};
